<template>
  <div>
    <div class="columns">
      <div class="column is-9">
        <b-notification :closable="false">
          {{ $t('compScenarioAdminDataAdmin.info-1') }}
        </b-notification>
        <div class="columns">
          <div class="column">
            <b-notification :closable="false">
              <div class="level-item has-text-centered">
                <div>
                  <p>
                    {{ $t('compScenarioAdminDataAdmin.nscenarios') }}
                  </p>
                  <div class="title is-size-4">
                    <p>
                      <span>{{ scenarios.length }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </b-notification>
          </div>
          <div class="column">
            <b-notification :closable="false">
              <div class="level-item has-text-centered">
                <div>
                  <p>
                    {{ $t('compScenarioAdminDataAdmin.navgrules') }}
                  </p>
                  <div class="title is-size-4">
                    <p>
                      <span>{{ avgNRules }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </b-notification>
          </div>
          <div class="column">
            <b-notification :closable="false">
              <b-button
                :label="$t('download')"
                type="is-primary"
                icon-left="download"
                @click="exportCSV()"
                expanded
              />
            </b-notification>
          </div>
        </div>
      </div>
      <div class="column">
        <b-carousel
          :autoplay="false"
          indicator-style="is-lines"
          :indicator-inside="true"
        >
          <b-carousel-item>
            <rules-pie
              :scenarios="scenarios"
              :exporting="false"
              :height="200"
              titleSize="14px"
            />
          </b-carousel-item>
          <b-carousel-item>
            <rules-bar
              :scenarios="scenarios"
              :exporting="false"
              :height="200"
              titleSize="14px"
            />
          </b-carousel-item>
        </b-carousel>
      </div>
    </div>
    <b-table
      :data="scenarios"
      :striped="true"
      :hoverable="true"
      :sort-icon="'angle-up'"
      paginated
      per-page="50"
    >
      <b-table-column
        :label="$t('compScenarioAdminDataAdmin.field-1')"
        sticky
        v-slot="props"
      >
        {{ props.row.name }}
      </b-table-column>
      <b-table-column
        :label="$t('compScenarioAdminDataAdmin.field-2')"
        v-slot="props"
      >
        {{ props.row.ghgi.year }}
      </b-table-column>
      <b-table-column
        :label="$t('compScenarioAdminDataAdmin.field-3')"
        v-slot="props"
      >
        {{ props.row.timeline }}
      </b-table-column>
      <b-table-column
        :label="$t('compScenarioAdminDataAdmin.field-4')"
        v-slot="props"
      >
        <b-taglist>
          <b-tag v-for="(rule, index) in props.row.rules" :key="index">
            {{ translate(rule, 'title') }}
          </b-tag>
        </b-taglist>
      </b-table-column>
      <section slot="empty" class="section">
        <div class="content has-text-grey has-text-centered">
          <p>
            <i class="fa fa-ban" style="font-size: 64px"></i>
          </p>
          <p>{{ $t('compScenarioAdminDataAdmin.no-scenario') }}</p>
        </div>
      </section>
    </b-table>
  </div>
</template>

<script>
import Rule from '@/models/scenario/Rule.js'
import { createExportFile } from '@/utils/files'
import { useSuperadminStore } from '@/stores/superadmin.js'

export default {
  name: 'Scenario1point5',
  components: {
    'rules-pie': () => import('@/components/graphics/RulesPie.vue'),
    'rules-bar': () => import('@/components/graphics/RulesBar.vue')
  },
  data () {
    return {}
  },
  setup () {
    const superadminStore = useSuperadminStore()
    return { superadminStore }
  },
  computed: {
    scenarios: function () {
      return this.superadminStore.scenarios
    },
    avgNRules: function () {
      let nrules = this.scenarios
        .map((obj) => obj.rules.length)
        .reduce((sum, a) => sum + a, 0)
      return Math.round((nrules / this.scenarios.length) * 100) / 100
    }
  },
  methods: {
    translate (rule, key) {
      return Rule.translate(rule, key, this.$i18n.locale)
    },
    exportCSV: function () {
      let csvContent =
        [
          'ghgi.uuid',
          'scenario.uuid',
          'name',
          'timeline',
          'description',
          'number.rules',
          'rule.name',
          'rule.level1',
          'rule.level2'
        ].join('\t') + '\n'
      for (let scenario of this.scenarios) {
        csvContent += scenario.ghgi.uuid + '\t' + scenario.uuid + '\t'
        csvContent += scenario.name + '\t' + scenario.timeline + '\t'
        csvContent += scenario.description + '\t' + scenario.rules.length + '\t'
        for (let rule of scenario.rules) {
          csvContent += rule.name + '\t' + JSON.stringify(rule.level1) + '\t'
          csvContent += JSON.stringify(rule.level2) + '\t'
        }
        csvContent += '\n'
      }
      createExportFile(csvContent, 'scenario')
    }
  },
  mounted () {
    const loadingComponent = this.$buefy.loading.open({
      container: null
    })
    this.superadminStore
      .getScenarios()
      .then((data) => {
        loadingComponent.close()
      })
      .catch(() => {
        loadingComponent.close()
      })
  }
}
</script>
